import '../classes/styles/style.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import React from 'react';
import GlobalProvider from './ContextProvider';
import Home from '../pages/home';
import Sedi from '../pages/sedi';
import Clienti from '../pages/clienti';
import Abbonamenti from '../pages/abbonamenti';
import Promozioni from '../pages/promozioni';
import Prenotazioni from '../pages/prenotazioni';
import Login from '../pages/loginScreen';
import Ordini from '../pages/ordini';

export interface IApplicationsProps { }

const App: React.FunctionComponent<IApplicationsProps> = (props) => {
  return (
    <GlobalProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home/" element={<Home />} />
          <Route path="/sedi/" element={<Sedi />} />
          <Route path="/clienti/" element={<Clienti />} />
          <Route path="/abbonamenti/" element={<Abbonamenti />} />
          <Route path="/promozioni/" element={<Promozioni />} />
          <Route path="/ordini/" element={<Ordini />} />
          <Route path="/prenotazioni/" element={<Prenotazioni />} />
        </Routes>
      </BrowserRouter>
    </GlobalProvider>
  );
}

export default App;

